import React from 'react'

// Grip shown on ToC rows when author tools are enabled. The dnd-kit listeners
// live here (not on the row itself) so plain clicks still navigate/toggle.
// Kept out of the tab order: drag-and-drop is pointer-only in this menu, and
// the dnd-kit keyboard attributes would fight the ToC's arrow-key navigation.
export const TocDragHandle = ({ listeners, title }) => (
  <span
    className="toc-drag-handle"
    {...listeners}
    tabIndex={-1}
    aria-hidden="true"
    title={`Drag to move ${title}`}
  >
    <i className="fa-solid fa-grip-dots-vertical" />
  </span>
)
